// extracted by mini-css-extract-plugin
export var box = "_3f-0";
export var check = "_3f-1";
export var checkboxButton = "_3f-6";
export var checkboxGroup = "_3f-5";
export var disabled = "_3f-7";
export var ghost = "_3f-9";
export var input = "_3f-2";
export var label = "_3f-4";
export var normal = "_3f-8";
export var uncheck = "_3f-3";